/* LOVE BOMB — scrolling timeline.

   Moves the merchant's image along the spine path as the section scrolls
   through the viewport.

   The position comes from getPointAtLength() on the real <path>, so the image
   sits exactly on the curve for any block count or viewport size. Because the
   SVG uses preserveAspectRatio="none", user units are stretched differently on
   each axis, so the point has to be mapped back to CSS pixels by hand — the
   browser's own CTM would be right, but reading it forces layout on every
   frame, and this runs on scroll. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(track) {
    var svg = track.querySelector('.lb-tl__spine');
    var path = track.querySelector('.lb-tl__spine-base');
    var trail = track.querySelector('.lb-tl__spine-trail');
    var rider = track.querySelector('[data-lb-timeline-rider]');
    if (!svg || !path || !rider) return;

    var vb = svg.viewBox.baseVal;
    var len = path.getTotalLength();
    var ticking = false;
    var visible = false;
    var trailLen = 0;

    // The trail is drawn in by dash offset. getTotalLength() reports USER
    // units, but the path carries vector-effect: non-scaling-stroke, which
    // makes dash lengths resolve in SCREEN units — and the viewBox is
    // stretched differently on each axis, so the two never agree. Feeding one
    // into the other broke the line into scattered segments. Measure the
    // rendered length by sampling the path in CSS pixels instead.
    function screenLength() {
      var box = svg.getBoundingClientRect();
      if (!box.width || !box.height) return 0;
      var sx = box.width / vb.width;
      var sy = box.height / vb.height;
      var steps = 240;
      var total = 0;
      var prev = path.getPointAtLength(0);
      for (var i = 1; i <= steps; i++) {
        var pt = path.getPointAtLength((i / steps) * len);
        var dx = (pt.x - prev.x) * sx;
        var dy = (pt.y - prev.y) * sy;
        total += Math.sqrt(dx * dx + dy * dy);
        prev = pt;
      }
      return total;
    }

    function measureTrail() {
      if (!trail) return;
      trailLen = screenLength();
      trail.style.strokeDasharray = trailLen;
      trail.style.strokeDashoffset = trailLen;
    }

    measureTrail();

    function progress() {
      var r = track.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // 0 when the top of the track reaches the middle-lower part of the
      // viewport, 1 when its bottom passes the middle-upper part. Anchoring to
      // the viewport centre rather than its edges means the image is already
      // moving while the section is comfortably in view.
      var start = vh * 0.85;
      var end = -r.height + vh * 0.35;
      var span = start - end;
      if (span <= 0) return 0;
      var p = (start - r.top) / span;
      return p < 0 ? 0 : p > 1 ? 1 : p;
    }

    function place() {
      ticking = false;

      var p = reduce.matches ? 0 : progress();
      var pt = path.getPointAtLength(p * len);

      // svg user units -> css px. Each axis scales independently. The rider is
      // positioned against the TRACK, while the point is in the SVG's box, and
      // the SVG no longer fills the track — so add the offset between them.
      var box = svg.getBoundingClientRect();
      var tb = track.getBoundingClientRect();
      var x = (pt.x / vb.width) * box.width + (box.left - tb.left);
      var y = (pt.y / vb.height) * box.height + (box.top - tb.top);

      rider.style.transform =
        'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%,-50%)';

      if (trail) {
        trail.style.strokeDashoffset = trailLen * (1 - p);
      }

      if (!rider.classList.contains('is-ready')) {
        rider.classList.add('is-ready');
      }
    }

    function onScroll() {
      if (ticking || !visible) return;
      ticking = true;
      window.requestAnimationFrame(place);
    }

    // Only listen while the section is on screen.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) onScroll();
        },
        { rootMargin: '200px 0px' }
      ).observe(track);
    } else {
      visible = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      len = path.getTotalLength();
      measureTrail();
      visible = true;
      onScroll();
    });

    // place once up front so the image never flashes at 0,0
    requestAnimationFrame(place);
    // and again after images settle, since the track height (and so the
    // rendered path length) changes once they have loaded
    window.addEventListener('load', function () {
      measureTrail();
      place();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-lb-timeline]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // theme editor: re-init when the section is redrawn
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
